import { useContext } from 'react'
import { getAddressSuggestionsEsri } from '../../services/api'
import { UserContext } from '../../state/user-state'
import { ValidationErrors } from '../../hooks/use-edit-form'
import { AddressFields, AddressSearch } from '@msaf/core-react'

interface AddressFieldProps {
  isSkeleton?: boolean
  labelledBy: string
  addressFields: AddressFields
  setAddressFields: (addressFields: AddressFields) => void
  isReadOnly?: boolean
  validationFieldErrors?: ValidationErrors
  allowManualEntry?: boolean
  isRequired?: boolean
}

export default function AddressField({
  isSkeleton,
  labelledBy,
  addressFields,
  setAddressFields,
  validationFieldErrors,
  allowManualEntry = true,
  isRequired = false,
  isReadOnly = false,
}: AddressFieldProps) {
  const { state } = useContext(UserContext)

  const getAddressSuggestions = async (query: string) => {
    const response = await getAddressSuggestionsEsri(query, 'Physical', state.token, state.auth_method)
    return response
  }

  return (
    <AddressSearch
      addressFields={addressFields}
      getAddressSuggestions={getAddressSuggestions}
      setAddressFields={setAddressFields}
      labelledBy={labelledBy}
      isReadOnly={isReadOnly}
      isSkeleton={isSkeleton}
      validationFieldErrors={validationFieldErrors ?? {}}
      allowManualEntry={allowManualEntry}
      isRequired={isRequired}
    />
  )
}
